export const registerStates = (states) => {

    states.customState = (state = { scrolled: false, submenu_id: -1 }, action) => {
        switch (action.type) {
            case 'SCROLLED':
                return { ...state, scrolled: action.scrolled };
            case 'SUBMENU_TOGGLED':
                return { ...state, submenu_id: action.id };
            default:
                return state;
        }
    };

    return states;
}
 